export default __webpack_public_path__ + "static/media/11-1.fa210e8f.mp3";